import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Card } from '../../../Card/Card.es.js';
import { Heading } from '../../../Heading/Heading.es.js';

const HeroCardImage = ({ imageUrl, title, description, level = 'page', className, children })=>{
    return jsxs(Card, {
        className: classNames('cb-hero-card', {
            page: level === 'page'
        }, className),
        "data-testid": "hero-card-image",
        children: [
            jsx("img", {
                className: "hero-card-image-background",
                "data-testid": "hero-card-image-background",
                src: imageUrl,
                "aria-hidden": true
            }),
            jsx("div", {
                className: classNames('hero-card-container'),
                children: jsxs("div", {
                    className: classNames('hero-card-content'),
                    children: [
                        jsxs(Heading, {
                            variant: level === 'page' ? 'page/md' : 'section/md',
                            children: [
                                jsx(Heading.Header, {
                                    children: title
                                }),
                                description && jsx(Heading.Intro, {
                                    children: description
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        ]
    });
};
HeroCardImage.displayName = 'HeroCardImage';

export { HeroCardImage };
//# sourceMappingURL=HeroCard.Image.es.js.map
